import React, { useState, useRef, useEffect } from "react";

const SubmitCancelButtonSlider = (props) => {
    const {
        // `infoSource` is intentionally NOT destructured/used anymore --
        // this component used to call `infoSource.language(...)` inline
        // during its own render to build the disabled-state hint text.
        // That call chain (laguangeElakay -> checkLangObjDefault ->
        // checkProdKeyExit, see src/includes/pageInside/dataElakay.jsx)
        // is pure today, but keeping ANY app-wide helper call inside this
        // component's render was the prime suspect for a persistent
        // "Cannot update a component (Orders) while rendering a
        // different component (SubmitCancelButtonSlider)" warning on
        // /myshop. Removing it entirely -- the caller now passes the
        // already-resolved hint text as `disabledHint` -- makes this
        // component's render provably free of any call into the wider
        // app, regardless of what that helper does internally now or in
        // the future.
        disabledHint = "",
        cancel = "Cancel",
        submit = "Submit",
        nrbTime = 3000,
        isDisabled= false,
        colSubmit = "#FFFFFF",
        colCancel = "#C0C0C0",
        colBGCdisplay = "#FFFFFF",
        colBorisplay = "#DCDCDC",
        width = "27%",
        submitfunction =()=> {},
    } = props
    const [isProcessing, setIsProcessing] = useState(false);
  const [progress, setProgress] = useState(0);
  const progressIntervalRef = useRef(null); // Référence pour l'intervalle
  const hasSubmitted = useRef(false); // Garde une trace si l'action a été soumise
  const isMountedRef = useRef(true); // Faux dès que ce composant est démonté

  // Sans ce nettoyage, un slide en cours (interval encore actif) continue
  // de tourner APRÈS que ce composant soit démonté -- ex: la modale se
  // ferme, ou canAcceptCapture bascule et remplace ce slider par un autre
  // (pré-/post-acceptation, voir orderShipped.js) pendant que l'intervalle
  // tourne encore. L'intervalle finit alors par appeler
  // setIsProcessing/setProgress sur une fibre disparue, PUIS submitfunction()
  // -- une fonction devenue obsolète (stale closure) -- exactement le genre
  // de timing qui produit "Cannot update a component while rendering a
  // different component" quand une NOUVELLE instance de ce même composant
  // est en train de se rendre au moment où cet appel tardif atterrit.
  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
      clearInterval(progressIntervalRef.current);
    };
  }, []);

  // Si isDisabled passe à true PENDANT un slide en cours (champs requis
  // qui redeviennent invalides, canAcceptCapture qui bascule, un autre
  // chargement qui démarre...), on arrête l'intervalle au lieu de le
  // laisser continuer à compter vers une action potentiellement invalide.
  useEffect(() => {
    if (isDisabled && isProcessing) {
      clearInterval(progressIntervalRef.current);
      setIsProcessing(false);
      setProgress(0);
      hasSubmitted.current = false;
    }
  }, [isDisabled, isProcessing]);

  const handleClick = () => {
    if (isProcessing) {
      // Annuler l'action en cours
      clearInterval(progressIntervalRef.current); // Arrêter l'intervalle immédiatement
      setIsProcessing(false);
      setProgress(0);
      hasSubmitted.current = false; // Réinitialise l'état soumis

    } else {
      // Commencer le traitement
      setIsProcessing(true);
      setProgress(0);
      hasSubmitted.current = false; // Réinitialise pour une nouvelle soumission

      const interval = 30; // Met à jour toutes les 30ms
      const totalTime =  nrbTime; // 3 secondes pour atteindre 100%
      const increment = (interval / totalTime) * 100;
      // Suivi du pourcentage en dehors de React (fermeture locale, pas
      // d'état) -- voir le commentaire ci-dessous pour pourquoi
      // setProgress(prev => ...) ne doit JAMAIS être utilisé ici.
      let currentProgress = 0;

      progressIntervalRef.current = setInterval(() => {
        if (!isMountedRef.current) {
          // Ce composant a été démonté pendant que l'intervalle tournait
          // (modale fermée, slider pré-/post-acceptation remplacé par
          // l'autre, etc.) -- ne JAMAIS appeler setProgress/setIsProcessing
          // ni submitfunction() sur une instance disparue. Le cleanup de
          // l'effet ci-dessus a déjà appelé clearInterval, mais on se
          // protège aussi ici contre un dernier tick déjà en file.
          clearInterval(progressIntervalRef.current);
          return;
        }

        currentProgress += increment;

        if (currentProgress >= 100) {
          clearInterval(progressIntervalRef.current); // Arrêter l'intervalle
          setProgress(100);
          setIsProcessing(false); // Réactiver le bouton

          // RACINE DU BUG "Cannot update a component (Orders) while
          // rendering a different component (SubmitCancelButtonSlider)":
          // submitfunction() (clickBtnAccept/clickBtnInfo dans
          // orderShipped.js, qui appellent setCheckoutState/
          // setShippingSaveState -- l'état d'Orders) vivait auparavant
          // À L'INTÉRIEUR de l'updater fonctionnel passé à
          // setProgress(prev => {...}). React APPELLE cet updater
          // PENDANT le rendu de CE composant (SubmitCancelButtonSlider)
          // pour calculer le nouvel état -- donc tout effet de bord posé
          // dedans (ici, mettre à jour l'état d'un AUTRE composant) se
          // produisait littéralement pendant que SubmitCancelButtonSlider
          // était en train de se rendre. C'est exactement l'anti-pattern
          // que ce warning React signale. En suivant `currentProgress`
          // dans une variable de fermeture locale au lieu de la forme
          // updater de useState, cet appel se produit maintenant au
          // niveau supérieur du callback setInterval -- un simple
          // callback asynchrone, jamais pendant un rendu -- donc
          // submitfunction() peut mettre à jour Orders en toute sécurité.
          if (!hasSubmitted.current && isMountedRef.current) {
            hasSubmitted.current = true; // Marque comme soumis pour éviter les répétitions
            submitfunction();
          }
        } else {
          setProgress(currentProgress);
        }
      }, interval);
    }
  };

  // Désactiver le bouton si les conditions ne sont pas remplies
//   const isDisabled = customer === null && payment_method === null;

  return (
    <div style={{ textAlign: "center", marginTop: "20px" }}>
      {/* Bouton avec slider intégré */}
      <button
        onClick={!isDisabled ? handleClick : undefined} // Désactive l'action si les conditions ne sont pas remplies
        disabled={isDisabled}
        style={{
          position: "relative",
          padding: "2px 1px",
          backgroundColor: isProcessing ? colCancel : colSubmit,
          color: isDisabled ? colBorisplay : "#000000",
          border: `2px solid ${isDisabled ? colBorisplay : "black"}`,
          borderRadius: "30px",
          cursor: isDisabled ? "not-allowed" : "pointer",
          overflow: "hidden",
          fontSize: "14px",
          width: width,
          float: "right"
        }}
      >
        <span style={{ position: "relative", zIndex: 1 }}>
          {isProcessing ? cancel : submit}
        </span>
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            height: "100%",
            width: `${progress}%`,
            backgroundColor: isDisabled ? colBGCdisplay : colSubmit,
            transition: "width 30ms linear",
          }}
        ></div>
      </button>
      {isDisabled && disabledHint && (
        <p style={{ marginTop: "10px", color: "#f44336", fontSize: "14px" }}>
          {disabledHint}
        </p>
      )}
    </div>
  );
};

export default SubmitCancelButtonSlider;
